import {useMemo} from "react";

export const useVideoMimeType = () => {
  return useMemo(() => {
    if (MediaRecorder.isTypeSupported('video/webm; codecs=vp9') || MediaRecorder.isTypeSupported('video/webm')) {
      return "video/webm"
    } else if (MediaRecorder.isTypeSupported('video/mp4')) {
      return "video/mp4"
    } else {
      alert("Your device does not support the required mimetype")
    }
  }, [])
}


export const useVideoFileType = () => {
  return useMemo(() => {
    if (MediaRecorder.isTypeSupported('video/webm; codecs=vp9') || MediaRecorder.isTypeSupported('video/webm')) {
      return "webm"
    } else if (MediaRecorder.isTypeSupported('video/mp4')) {
      return "mp4"
    } else {
      alert("Your device does not support the required mimetype")
    }
  }, [])
}

export const readFileAsDataURL = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      resolve(event.target.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};